import getProperty from 'lodash.get';
import {numberToFixed} from '../../helpers';

export const getSummaryCost = (name, summaryData) => {
  const summaryCost = numberToFixed (
    getProperty (summaryData, [name, 'sectionSummary', 'cost'], 0),
    2
  );
  return summaryCost ? summaryCost : '';
};



// WEBPACK FOOTER //
// ./src/components/StackedBarChart/StackedBarChartHelpers.js